class RevisionIndependent {
    constructor(data, store){
        this.data = data;
        this.store = store;
    }
}
export { RevisionIndependent };
